module.exports = __webpack_public_path__ + "static/media/32.c116cda5.jpg";